<div class="video" [class.has--popup]="!inline()" (mouseenter)="previewVideo(true)" (mouseleave)="previewVideo(false)">
  <div class="video__overlay" [class.is--hidden]="state === 1">
    <img [src]="youtubePoster$()" [alt]="videoAltText$()" loading="lazy" />

    <button
      class="button button-icon button--{{ color() }} button--lg"
      aria-label="Video afspelen"
      (click)="playVideo()"
      [disabled]="previewOnly()"
    >
      <fstr-icon anchor="icon-play-fill" *ngIf="state !== 1 && state !== 3"></fstr-icon>
      <fstr-icon anchor="icon-spinner" class="anim--spinning" *ngIf="state === 3"></fstr-icon>
    </button>
  </div>

  @if (!previewOnly() && inline()) {
    <fstr-youtube-player
      (ready)="onPlayerReady($event)"
      (change)="onPlayerChange($event)"
      #youtube
      [src]="url()"
      [config]="youtubeConfig()"
      [cookies]="cookiePreferences()?.marketing || false"
    ></fstr-youtube-player>
  }
</div>
